import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import Link from '@material-ui/core/Link';
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import ReloadIcon from '@material-ui/icons/Replay';
import ResetIcon from '@material-ui/icons/Cached';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import { auth } from '../common/firebase';
import * as validator from 'validator';


import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    email: false,
    displayName: false,
    creationTime: true,
    lastSignInTime: true,
    roles: false,
    phone: false,
    notify: false,
    pageSize: 10,
};

const RoleType = {
    "ADMIN": i18n.get("users.role.ADMIN"),
    "OWNER": i18n.get("users.role.OWNER"),
    "EDITOR": i18n.get("users.role.EDITOR"),
    "ASSISTANT": i18n.get("users.role.ASSISTANT"),
    "READER": i18n.get("users.role.READER"),
}

const suggestions = [
    { name: i18n.get("users.role.ADMIN"), value: "ADMIN" },
    { name: i18n.get("users.role.OWNER"), value: "OWNER" },
    { name: i18n.get("users.role.EDITOR"), value: "EDITOR" },
    { name: i18n.get("users.role.ASSISTANT"), value: "ASSISTANT" },
    { name: i18n.get("users.role.READER"), value: "READER" },
];

const defaultsPropertyName = 'p71.users.defaults';

class Users extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    getInput = (data) => {
        try {
            if (!validator.isEmail(data.email) || data.roles.length === 0) {
                throw new Error(i18n.get('users.error.validation'));
            }
            if (data.phone && !validator.isMobilePhone(data.phone, "de-DE")) {
                throw new Error(i18n.get('users.error.validation'));
            }
            if (data.notify === true && !data.phone) {
                throw new Error(i18n.get('users.error.validation'));
            }

            const input = {
                email: data.email.trim(),
                roles: data.roles.map((r) => r.value),
                phone: data.phone ? data.phone.trim() : null,
                notify: data.notify ? data.notify : null,
                displayName: data.displayName ? data.displayName.trim() : null,
            };

            return input;
        } catch (error) {
            throw new Error(i18n.get('users.error.validation'));
        }
    };

    mapField(column) {
        return column;
    }

    getSuggestions(value) {
        const inputValue = value ? value.trim().toLowerCase() : '';
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : suggestions.filter((suggestion) => {
                const keep = count < 5 && suggestion.name.toLowerCase().slice(0, inputLength) === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    getDefaultSuggestions() {
        return suggestions;
    }

    changeUserStatusAction = (rowData) => {
        return {
            icon: rowData.disabled ? CheckIcon : BlockIcon,
            tooltip: rowData.disabled
                ? i18n.get('users.changeUserStatus.label.enable')
                : i18n.get('users.changeUserStatus.label.disable'),
            onClick: async (event, rowData) => {
                try {
                    if (rowData.disabled) {
                        await graphql.clientWithToken(this.props.accessToken).mutate({
                            variables: {
                                id: rowData.id,
                            },
                            mutation: gql`
                                mutation unlockUser($id: ID!) {
                                unlockUser(id: $id) {
                                    id
                                }
                            }
                        `,
                        });
                        this.showMessage(i18n.get('users.changeUserStatus.action.enable.success'), 'success');
                    } else {
                        await graphql.clientWithToken(this.props.accessToken).mutate({
                            variables: {
                                id: rowData.id,
                            },
                            mutation: gql`
                                mutation lockUser($id: ID!) {
                                lockUser(id: $id) {
                                    id
                                }
                            }
                        `,
                        });
                        this.showMessage(i18n.get('users.changeUserStatus.action.disable.success'), 'success');
                    }
                    this.tableRef.current.onQueryChange();
                } catch (error) {
                    this.showMessage('users.changeUserStatus.error', 'error');
                }
            },
        };
    };

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("users.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            editable: 'never',
                            sorting: true,
                            filtering: false,
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                        },
                        {
                            title: i18n.get("users.email"),
                            field: 'email',
                            hidden: this.default("email"),
                            editable: 'onAdd',
                            sorting: true,
                            filtering: true,
                            customSort: () => 0,
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            render: (rowData) => {
                                return rowData.email ? <Link href={`mailto:${rowData.email}`}>{rowData.email}</Link> : '-';
                            },
                        },
                        {
                            title: i18n.get("users.displayName"),
                            field: 'displayName',
                            hidden: this.default("displayName"),
                            sorting: true,
                            filtering: true,
                            customSort: () => 0,
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            render: (rowData) => {
                                return rowData.displayName ? rowData.displayName : '-';
                            },
                        },
                        {
                            title: i18n.get("users.roles"),
                            field: 'roles',
                            hidden: this.default("roles"),
                            sorting: false,
                            filtering: true,
                            lookup: RoleType,
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            render: rowData => {
                                return rowData && rowData.roles ? rowData.roles.map(role => <Chip label={i18n.get(`users.role.${role}`)} value={role} style={{ marginRight: 8, marginBottom: 8 }} />) : null
                            },
                            editComponent: (props) => {
                                return helper._chips(
                                    props,
                                    props.value
                                        ? props.value.map((value) => {
                                            return { name: RoleType[value], value: value };
                                        })
                                        : [],
                                    i18n.get('users.roles.label'),
                                    i18n.get('required'),
                                    this.getSuggestions,
                                    this.getDefaultSuggestions,
                                    4
                                );
                            },
                        },
                        {
                            title: i18n.get("users.phone"),
                            field: 'phone',
                            hidden: this.default("phone"),
                            sorting: true,
                            filtering: true,
                            customSort: () => 0,
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            render: (rowData) => {
                                return rowData.phone ? rowData.phone : '-';
                            },
                        },
                        {
                            title: i18n.get("users.creationTime"),
                            field: 'creationTime',
                            hidden: this.default("creationTime"),
                            sorting: true,
                            filtering: true,
                            editable: 'never',
                            type: "date",
                            emptyValue: '-',
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            filterComponent: helper.DateRangeFilter,
                        },
                        {
                            title: i18n.get("users.lastSignInTime"),
                            field: 'lastSignInTime',
                            hidden: this.default("lastSignInTime"),
                            sorting: true,
                            filtering: true,
                            editable: 'never',
                            type: "date",
                            emptyValue: '-',
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            filterComponent: helper.DateRangeFilter,
                        },
                        {
                            title: i18n.get("users.notify"),
                            field: 'notify',
                            hidden: this.default("notify"),
                            type: "boolean",
                            sorting: true,
                            filtering: true,
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                        },
                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {
                                const where = helper.whereString(query["filters"], this.mapField);
                                const orderBy = helper.orderByString(query, this.mapField, "email")

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        users(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on User {
                                                    id
                                                    email
                                                    displayName
                                                    creationTime { X }
                                                    lastSignInTime { X }
                                                    roles
                                                    phone
                                                    notify
                                                    disabled
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.users.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                email: element.email,
                                                displayName: element.displayName,
                                                creationTime: element.creationTime && element.creationTime.X ? moment(element.creationTime.X, 'X').toDate() : null,
                                                lastSignInTime: element.lastSignInTime && element.lastSignInTime.X ? moment(element.lastSignInTime.X, 'X').toDate() : null,
                                                roles: element.roles,
                                                phone: element.phone,
                                                notify: element.notify,
                                                disabled: element.disabled
                                            };
                                        }),
                                    totalCount: result.data.users.totalCount
                                }
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[
                        {
                            isFreeAction: true,
                            icon: () => { return <ReloadIcon /> },
                            tooltip: i18n.get("general.reload"),
                            onClick: async (event, rowData) => {
                                this.tableRef.current.onQueryChange();
                            },
                        },
                        {
                            icon: ResetIcon,
                            tooltip: i18n.get('users.resetPassword.label'),
                            onClick: async (event, rowData) => {
                                try {
                                    await auth.sendPasswordResetEmail(rowData.email);
                                    this.showMessage(i18n.get('users.resetPassword.success'), 'success');
                                } catch (error) {
                                    this.showMessage('users.resetPassword.error', 'error');
                                }
                            },
                        },
                        this.changeUserStatusAction,
                    ]}
                    title={i18n.get("users.title")}
                    options={{
                        actionsColumnIndex: -1,
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                    }}
                    editable={{
                        isEditable: (rowData) => isInRoles(this.props.roles, [ROLE_ADMIN]),
                        isDeletable: (rowData) => isInRoles(this.props.roles, [ROLE_ADMIN]),
                        onRowAdd: isInRoles(this.props.roles, [ROLE_ADMIN])
                            ? (newData) =>
                                new Promise(async (resolve, reject) => {
                                    try {
                                        const input = this.getInput(newData);

                                        await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                roles: input.roles,
                                                email: input.email,
                                                phone: input.phone,
                                                notify: input.notify,
                                                displayName: input.displayName
                                            },
                                            mutation: gql`
                                                mutation createUser($email: String!, $roles: [Role], $displayName: String, $phone: String, $notify: Boolean) {
                                                    createUser(email: $email, roles: $roles, displayName: $displayName, phone: $phone, notify: $notify) {
                                                    id
                                                    }
                                                }
                                            `,
                                        });

                                        this.showMessage(i18n.get('users.message.onRowAdd.success'), 'success');

                                        resolve();
                                    } catch (error) {
                                        this.showMessage(i18n.get('users.message.onRowAdd.error'), 'error', error.message);
                                        reject(error);
                                    }
                                })
                            : null,

                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {
                                try {

                                    const input = this.getInput(newData)

                                    if (helper.diffArray(newData.roles, oldData.roles).length > 0) {
                                        const addedRoles = helper.diffArray(
                                            newData.roles.map((g) => g.value),
                                            oldData.roles
                                        );
                                        const removedRoles = helper.diffArray(
                                            oldData.roles,
                                            newData.roles.map((g) => g.value)
                                        );

                                        for (const addedRole of addedRoles) {
                                            await graphql.clientWithToken(this.props.accessToken).mutate({
                                                variables: {
                                                    id: newData.id,
                                                    role: addedRole,
                                                },
                                                mutation: gql`
                                                    mutation assignRoleToUser($id: ID!, $role: Role) {
                                                    assignRoleToUser(id: $id, role: $role) {
                                                        id
                                                    }
                                                }
                                            `,
                                            });
                                        }

                                        for (const removedRole of removedRoles) {
                                            await graphql.clientWithToken(this.props.accessToken).mutate({
                                                variables: {
                                                    id: newData.id,
                                                    role: removedRole,
                                                },
                                                mutation: gql`
                                                    mutation unassignRoleFromUser($id: ID!, $role: Role) {
                                                    unassignRoleFromUser(id: $id, role: $role) {
                                                        id
                                                    }
                                                }
                                            `,
                                            });
                                        }

                                    }

                                    const profile = {}
                                    if (newData.phone !== oldData.phone) profile["phone"] = input.phone
                                    if (newData.notify !== oldData.notify) profile["notify"] = input.notify

                                    if (Object.keys(profile).length > 0) {
                                        await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                id: newData.id,
                                                phone: input.phone ? input.phone : null,
                                                notify: input.notify ? input.notify : null,
                                            },
                                            mutation: gql`
                                                mutation updateUserProfile($id: ID!, $phone: String, $notify: Boolean) {
                                                updateUserProfile(id: $id, phone: $phone, notify: $notify) {
                                                    id
                                                }
                                            }`
                                        })
                                    }

                                    if (newData.displayName !== oldData.displayName) {
                                        await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                id: newData.id,
                                                displayName: input.displayName ? input.displayName : null,
                                            },
                                            mutation: gql`
                                                mutation updateUser($id: ID!, $displayName: String) {
                                                updateUser(id: $id, displayName: $displayName) {
                                                    id
                                                }
                                            }`
                                        })
                                    }

                                    this.showMessage(i18n.get('users.message.onRowUpdate.success'), 'success');

                                    resolve();
                                } catch (error) {
                                    this.showMessage(i18n.get('users.message.onRowUpdate.error'), 'error', error.message);
                                    reject(error);
                                }
                            }),

                        onRowDelete: (oldData) =>
                            new Promise(async (resolve, reject) => {
                                try {
                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            id: oldData.id,
                                        },
                                        mutation: gql`
                                            mutation deleteUser($id: ID!) {
                                                deleteUser(id: $id)
                                            }
                                        `,
                                    });

                                    this.showMessage(i18n.get('users.message.onRowDelete.success'), 'success');

                                    resolve(result);
                                } catch (error) {
                                    this.showMessage(i18n.get('users.message.onRowDelete.error'), 'error', error.message);
                                    reject(error);
                                }
                            }),
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

Users.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Users))